import { NodeType, } from './Node';
export class BaseVisitor {
    getNodeId(node) {
        return node.location.start.offset;
    }
    visit(node) {
        switch (node.type) {
            case 'Identifier':
                this.visitIdentifierNode(node);
                break;
            case 'NullLiteral':
                this.visitNullLiteralNode(node);
                break;
            case 'BooleanLiteral':
                this.visitBooleanLiteralNode(node);
                break;
            case 'NumberLiteral':
                this.visitNumberLiteralNode(node);
                break;
            case 'HexLiteral':
                this.visitHexLiteralNode(node);
                break;
            case 'StringLiteral':
                this.visitStringLiteralNode(node);
                break;
            case 'RegExpLiteral':
                this.visitRegExpLiteralNode(node);
                break;
            case 'FieldLiteral':
                this.visitFieldLiteralNode(node);
                break;
            case 'DateLiteral':
                this.visitDateLiteralNode(node);
                break;
            case 'UnaryExpression':
                this.visitUnaryExpressionNode(node);
                break;
            case 'BinaryExpression':
                this.visitBinaryExpressionNode(node);
                break;
            case 'LogicalExpression':
                this.visitLogicalExpressionNode(node);
                break;
            case 'CaseExpression':
                this.visitCaseExpressionNode(node);
                break;
            case 'CallExpression':
                this.visitCallExpressionNode(node);
                break;
        }
    }
    visitAll(tree) {
        tree.nodes.forEach((node) => {
            this.visit(node);
        });
    }
    visitIdentifierNode(node) {
        return undefined;
    }
    visitNullLiteralNode(node) {
        return undefined;
    }
    visitBooleanLiteralNode(node) {
        return undefined;
    }
    visitNumberLiteralNode(node) {
        return undefined;
    }
    visitHexLiteralNode(node) {
        return undefined;
    }
    visitStringLiteralNode(node) {
        return undefined;
    }
    visitRegExpLiteralNode(node) {
        return undefined;
    }
    visitFieldLiteralNode(node) {
        return undefined;
    }
    visitDateLiteralNode(node) {
        return undefined;
    }
    visitUnaryExpressionNode(node) {
        return undefined;
    }
    visitBinaryExpressionNode(node) {
        return undefined;
    }
    visitLogicalExpressionNode(node) {
        return undefined;
    }
    visitCaseExpressionNode(node) {
        return undefined;
    }
    visitCallExpressionNode(node) {
        return undefined;
    }
}
export class Pipeline {
    constructor() {
        this._visitors = new Array();
    }
    get visitors() {
        return this._visitors;
    }
    addVisitor(visitor) {
        this.visitors.push(visitor);
    }
    visit(node) {
        this.visitors.forEach((visitor) => {
            node.accept(visitor);
        });
    }
    visitAll(tree) {
        tree.nodes.forEach((node) => {
            this.visit(node);
        });
    }
    visitDepthFirst(node) {
        this._visitDepthFirst(node);
    }
    visitAllDepthFirst(tree) {
        tree.nodes.forEach((node) => {
            this.visitDepthFirst(node);
        });
    }
    _visitDepthFirst(node) {
        switch (node.type) {
            case NodeType.UnaryExpression: {
                const uExprNode = node;
                this._visitDepthFirst(uExprNode.argument);
                break;
            }
            case NodeType.BinaryExpression:
            case NodeType.LogicalExpression: {
                const binExprNode = node;
                this._visitDepthFirst(binExprNode.left);
                this._visitDepthFirst(binExprNode.right);
                break;
            }
            case NodeType.CaseExpression: {
                const caseExprNode = node;
                caseExprNode.when.forEach((when) => {
                    const whenNode = when;
                    this._visitDepthFirst(whenNode.condition);
                    this._visitDepthFirst(whenNode.result);
                });
                const elseNode = caseExprNode.else;
                if (elseNode != null) {
                    this._visitDepthFirst(elseNode.result);
                }
                break;
            }
            case NodeType.CallExpression: {
                const callExprNode = node;
                callExprNode.arguments.forEach((arg) => {
                    this._visitDepthFirst(arg);
                });
                break;
            }
        }
        this.visit(node);
    }
}
export class Validator extends BaseVisitor {
    constructor() {
        super();
        this._errors = new Array();
    }
    get errors() {
        return this._errors;
    }
    get isValid() {
        return this.errors.length === 0;
    }
    get isInvalid() {
        return this.errors.length > 0;
    }
    addError(node, message) {
        this.errors.push({ node, message });
    }
}
